// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function exhaustiveCheck(_param: never): never {
  throw new Error("Should not reach here");
}
